/**
 * Data classification helper for AI For Me intake form
 * Handles default data classification logic based on platform types
 */

import { BasePlatform, DataClassification, PlatformName } from "../constants/platform-constants";
import { PlatformDetectionResult } from "./platform-detection-helper";

/**
 * Helper function to get the dynamic public data classification value prior to conversion from Public to Public Data
 * @param dataClassifications - Array of available data classifications from the API
 * @returns The dynamic public classification value (e.g., "Public" or "Public Data")
 */
export const getPublicDataClassificationValue = (dataClassifications: string[]): string => {
  const foundClassification = dataClassifications.find((classification) =>
    classification.toLowerCase().includes("public")
  );

  return foundClassification || "Public Data";
};

/**
 * Gets the default data classification based on platform type and extracted data
 * @param urlAnalysis - The URL analysis result containing platform information
 * @param defaultPublicClassification - The dynamic public classification value (e.g., "Public" or "Public Data")
 * @returns Default data classification string
 */
export function getDefaultDataClassification(
  urlAnalysis: PlatformDetectionResult | null,
  defaultPublicClassification: string
): string {
  if (!urlAnalysis?.basePlatform) return defaultPublicClassification;

  if (urlAnalysis.platformName == PlatformName.THIRD_PARTY) {
    return DataClassification.UNKNOWN;
  }

  switch (urlAnalysis.basePlatform) {
    case BasePlatform.CEDRIC:
    case BasePlatform.AMAZON_Q:
    case BasePlatform.AZA:
    case BasePlatform.MENTOR:
      return DataClassification.BUSINESS_DATA;
    case BasePlatform.PARTYROCK_INTERNAL:
      return DataClassification.BUSINESS_DATA;
    case BasePlatform.PARTYROCK_EXTERNAL:
      return defaultPublicClassification;
    default:
      return defaultPublicClassification;
  }
}
